import { Component, Input } from '@angular/core';
import { NzRateModule } from 'ng-zorro-antd/rate';
import { FormsModule } from '@angular/forms';
import { TranslocoDirective } from '@jsverse/transloco';
import { DatePipe } from '@angular/common';
import { IReview } from '../../../core/services';

@Component({
  selector: 'app-mb-rating-component',
  imports: [NzRateModule, FormsModule, TranslocoDirective, DatePipe],
  templateUrl: './mb-rating-component.component.html',
})
export class MbRatingComponentComponent {
  @Input() review: IReview | null = null;
}
